<div class="flex flex-row w-full justify-between group-text-hover cursor-pointer">
    <div class="flex w-2/3 pl-6">
        <app-operator-icon [path]="operator().icon" />
        <p class="status-text text-hover">{{ operator().firstname }}</p>
        <p class="status-text text-hover">{{ operator().lastname }}</p>
    </div>
    <div class="flex w-1/3 justify-evenly items-end">
        <div class="flex w-1/2 justify-end pr-2">
            <p class="text-hover text-right min-w-[8ch]">{{ operator().count }}</p>
        </div>
        <div class="flex w-1/2 justify-end pr-6">
            <p class="text-hover text-right min-w-[4ch]">{{ operator().percentage }} %</p>
        </div>
    </div>
</div>
